import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { pageView } from "../utils/analytics";

/**
 * Reusable layout component for service detail pages
 */
const ServiceDetailLayout = ({
  title,
  description,
  image,
  imageAlt,
  children,
}) => {
  useEffect(() => pageView());

  return (
    <React.Fragment>
      <Helmet>
        <title>{title} - The Moffat Foot Clinic</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <section className="gel-wrap spacing-slice--large">
        <div className="spacing-slice--large spacing-slice--large--bottom">
          <div className="service-detail-container">
            {/* Full width image */}
            <div className="service-detail-image">
              <img src={image} alt={imageAlt} />
            </div>

            {/* Content */}
            <div className="service-detail-content">{children}</div>

            {/* Action buttons */}
            <div className="service-detail-actions">
              <NavLink
                className="button gs-u-pv+ gs-u-ph++ gs-u-mr+ gs-u-mb+"
                to="/foot-clinic/booking"
              >
                <FontAwesomeIcon icon={faCalendarAlt} className="gs-u-mr" />
                Book Appointment
              </NavLink>
              <NavLink
                to="/foot-clinic"
                className="button button--secondary gs-u-pv+ gs-u-ph++"
              >
                View All Services
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ServiceDetailLayout;
